// extracted by mini-css-extract-plugin
export default {"productList":"productList_productList__x9f8L"};